import moment from 'moment';
import mutations from './mutations';
import actions from './actions';

export default {
  namespaced: true,
  modules: {
  },
  state: {
    filters: {
      routeName: '',
      parameters: {}
    }
  },
  getters: {
    filters: (state) => {
      return state.filters;
    },
  },
  mutations,
  actions
};
